import api from './api';

const ENDPOINT = 'featured-banners';

const FeaturedBannerService = {
  getRandom: () => api.get(`${ENDPOINT}/random`),
};

export default FeaturedBannerService;
